var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"popularPicks-wrapper"},[_c('div',{staticClass:"main"},[_c('div',{staticClass:"title"},[_vm._v("热门精选")]),_c('div',{staticClass:"list flex-bt"},_vm._l((_vm.list),function(item,index){return _c('SmallNews',{key:index,attrs:{"data":item}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }